import { MODE_DEV, MODE_PROD } from 'root/settings'
import { getSchema } from '../utils'

export const INTERNAL_CONTACT = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            email: 'email',
            phoneNumber: 'phoneNumber'
        }),
        [MODE_PROD]: Object.freeze({
            email: 'e',
            phoneNumber: 'pn'
        })
    })
})()

export const EXTERNAL_CONTACT = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            email: 'email',
            phoneNumber: 'phoneNumber'
        }),
        [MODE_PROD]: Object.freeze({
            email: 'e',
            phoneNumber: 'pn'
        })
    })
})()

export const DAYS = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            monday: 'monday',
            tuesday: 'tuesday',
            wednesday: 'wednesday',
            thursday: 'thursday',
            friday: 'friday',
            saturday: 'saturday',
            sunday: 'sunday'
        }),
        [MODE_PROD]: Object.freeze({
            monday: 'm',
            tuesday: 't',
            wednesday: 'w',
            thursday: 'th',
            friday: 'f',
            saturday: 's',
            sunday: 'su'
        })
    })
})()

export const ROUTE_RULES = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            start: 'start',
            end: 'end',
            cutoff: 'cutoff',
            days: 'days',
            visibility: 'visibility'
        }),
        [MODE_PROD]: Object.freeze({
            start: 's',
            end: 'e',
            cutoff: 'co',
            days: 'd',
            visibility: 'v'
        })
    })
})()

export const FEE_RULES = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            feeType: 'feeType',
            value: 'value',
            parameterField: 'parameterField',
            rangeStart: 'rangeStart',
            rangeEnd: 'rangeEnd'
        }),
        [MODE_PROD]: Object.freeze({
            feeType: 'ft',
            value: 'v',
            parameterField: 'pf',
            rangeStart: 'rs',
            rangeEnd: 're'
        })
    })
})()

export const COURIERS = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            internalContact: 'internalContact',
            externalContact: 'externalContact',
            visibility: 'visibility',
            feeDynamic: 'feeDynamic',
            feeRules: 'feeRules',
            name: 'name',
            detail: 'detail',
            orderStatus: 'orderStatus',
            routeRulesType: 'routeRulesType',
            routeRules: 'routeRules'
        }),
        [MODE_PROD]: Object.freeze({
            internalContact: 'ic',
            externalContact: 'ec',
            visibility: 'v',
            feeDynamic: 'fd',
            feeRules: 'fr',
            name: 'n',
            detail: 'd',
            orderStatus: 'os',
            routeRulesType: 'rrt',
            routeRules: 'rr',
            phoneNumber: 'pn'
        })
    })
})()
